import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2628682c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = {
  class: "flex abormal-flex",
  style: {"padding-top":"27px"}
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex abormal-flex" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "flex abormal-flex border-style" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "handle-way-body" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "mark-title" }
const _hoisted_16 = {
  key: 0,
  class: "handlingTips"
}
const _hoisted_17 = { style: {"width":"100%"} }
const _hoisted_18 = { style: {"width":"100%"} }
const _hoisted_19 = { style: {"width":"100%"} }
const _hoisted_20 = { class: "flex-b align-item" }
const _hoisted_21 = { style: { display: 'flex' } }
const _hoisted_22 = { class: "handle-way-table-title" }
const _hoisted_23 = { class: "handle-way-table-desc" }
const _hoisted_24 = { class: "handle-way-table-batch" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "flex-ter text-name-order mt_8" }
const _hoisted_27 = { class: "name" }
const _hoisted_28 = {
  key: 0,
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}
const _hoisted_29 = {
  key: 0,
  class: "required-style"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_31 = { class: "dialog-footer" }

import { t } from '@/plugins/i18n'
import { ref, onMounted, toRaw, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import STable from '@/components/Table/index.vue'
import { tableConfigSkuDialog, skuDialogColumns, changeReasonCodes } from './data'
import { processAbnormalDeliveryOrder } from '@/apis/order'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { useRequest } from '@/util/useLoading'
import { expressCostPdf, useSite } from '@/store'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  deliveryProcessType: {
    type: Number,
    default: 0
  }
},
  emits: ['closeDialog', 'refresh'],
  setup(__props, { emit }) {

const props = __props

const [loading, submitApi] = useRequest(processAbnormalDeliveryOrder)

const _processSkuList: any = ref([])
const selectionSkuList: any = ref([])
const batchValue = ref('')
const itemRef = []
const selectRef = (el: any) => {
  if (el) {
    itemRef.push(el)
  }
}
/** 处理方式 */
const handlingWays = ref(props.rowItem.recommendShipConfigId === '-1' ? 'CANCEL' : '')
/** 提交按钮是否disabled */
const showSubmitDisabled = ref(false)

const handleScroll = () => {
  itemRef.forEach((item) => {
    item.blur()
  })
}

onMounted(() => {
  setTimeout(() => {
    // 获取 DOM 元素
    const scrollAreaRef = document.querySelector('.handle-way-table .el-scrollbar__wrap')

    // 监听滚动事件
    scrollAreaRef!.addEventListener('scroll', handleScroll)
  }, 60)

  const arr = props.rowItem?.details || []
  if (arr?.length <= 0) {
    return
  }
  // 深拷贝下数组
  const newArr = JSON.parse(JSON.stringify(arr))
  const newList = newArr?.map((item: any) => {
    if (item.recommendShipConfigId === '-1') {
      return { ...item, confirmType: 'CANCEL' }
    }
    // 如果建议运输方式和原运输方式一致，则直接return
    if (item.originalDistributionId === item.recommendShipConfigId) {
      return item
    }
    // 如果变更理由不为价格过高，处理方式只有建议运输方式
    if (item.changeReasonCode && item.changeReasonCode !== 'AR_0010') {
      return { ...item, confirmType: 'RECOMMEND' }
    }
    return item
  })?.toSorted((a: any, b: any) => {
    // 1、变更理由不为请选择且不是取消发货，需要放在前面
    // 2、如果建议运输方式和原运输方式一致放在后面
    const _aChangecode = (a.changeReasonCode === 'AR_0000' || a.cancelDelivery) || a.originalDistributionId === a.recommendShipConfigId ? '' : a.changeReasonCode
    const _bChangecode = (b.changeReasonCode === 'AR_0000' || b.cancelDelivery) || b.originalDistributionId === b.recommendShipConfigId ? '' : b.changeReasonCode
    return Number(Boolean(_bChangecode)) - Number(Boolean(_aChangecode))
  })
  /** 如果所有商品都是没有变更理由的，提交按钮不可点击 */
  const isNeedFillIn = newList?.every((item: any) => !item?.changeReasonCode)
  showSubmitDisabled.value = isNeedFillIn

  _processSkuList.value = newList
})
onUnmounted(() => {
  // 移除滚动事件监听
  window.removeEventListener('scroll', handleScroll)
})

/** 批量选择-点击Selection */
const handleSelectionChange = (val: any) => {
  const list = val.map((item: any) => {
    if (item.changeReasonCode) {
      return item
    }
  })?.filter((item: any) => !!item) || []
  selectionSkuList.value = list
}
/** change select */
const changeSelect = (val: string, row: any) => {
  const { deliveryReviewDetailId } = row
  const _data = JSON.parse(JSON.stringify(_processSkuList.value))
  const arr = _data?.map((item: any) => item.deliveryReviewDetailId)
  const index = arr.indexOf(deliveryReviewDetailId)
  // 如果有值，则去掉必填校验
  if (val) {
    _processSkuList.value[index].hasNoContent = false
  }
  _processSkuList.value[index].confirmType = val
}
/** 批量选择处理方式 */
const changeBatchSelect = (val: string) => {
  const list = toRaw(selectionSkuList.value)
  const ids = list?.map((item: any) => item.deliveryReviewDetailId) || []
  console.log(ids, _processSkuList.value)
  const newList = _processSkuList.value?.map((item: any) => {
    const arr = ['CANCEL']
    if (ids.includes(item.deliveryReviewDetailId)) {
      // 如果变更理由不是价格过高，则没有保持原装选项
      // if (item.changeReasonCode !== 'AR_0010') {
      //   arr = ['RECOMMEND', 'CANCEL']
      // }
      // if (item.changeReasonCode === 'AR_0005') {
      //   arr = ['CANCEL']
      // }
      if (item.recommendShipConfigId !== '-1') {
        arr.push('RECOMMEND')
        if (item.changeReasonCode === 'AR_0010') {
          arr.push('REMAINING')
        }
      }
      // 如果有该选项则修改，没有就不变
      if (arr.includes(val)) {
        item.confirmType = val
        item.hasNoContent = false
      }
    }
    return item
  })
  _processSkuList.value = newList
}
/** 取消提交 */
const cancel = () => {
  emit('closeDialog', { visible: false })
}

/** 提交 */
const submit = () => {
  if (props.deliveryProcessType === 0) {
    if (!handlingWays.value) {
      ElMessage.error(t('请选择处理方式'))
      return
    }
    let _confirmType: undefined | number = ['RECOMMEND', 'CANCEL', 'REMAINING'].indexOf(handlingWays.value)
    _confirmType = _confirmType === -1 ? undefined : _confirmType + 1
    const { deliveryReviewCode, platformOrderNo } = props.rowItem
    const params = {
      deliveryReviewCode,
      platformOrderNo,
      confirmType: _confirmType
    }
    submitApi(params).then((res: any) => {
      const { success = false } = res
      if (!success) return
      emit('closeDialog', { visible: false })
      if (handlingWays.value === 'RECOMMEND') {
        ElMessage.success(t('成功，此国际发货单将按照建议运输方式发货'))
      }
      if (handlingWays.value === 'REMAINING') {
        ElMessage.success(t('成功，此国际发货单将保持原运输方式发货'))
      }
      emit('refresh')
    })
    return
  }
  const list = toRaw(_processSkuList.value)
  // 变更理由为请选择的需要写死字段
  const _list = JSON.parse(JSON.stringify(list)).map((item: any) => {
    // 如果为取消发货，那么直接写死类型为取消发货
    if (item.cancelDelivery) {
      item.confirmType = 'CANCEL'
      return item
    }
    // 如果变更理由为请选择，那么直接写死为（按照原来方式运输）
    if (item.changeReasonCode === 'AR_0000') {
      item.confirmType = 'REMAINING'
    }
    // 如果建议运输方式和原运输方式一样，那么直接写死为（按照原来方式运输）
    if (item.recommendShipConfigId === item.originalDistributionId) {
      item.confirmType = 'REMAINING'
    }
    return item
  })
  /** 判断有select是否都必填 */
  const isQuired = _list?.every((item: any) => {
    if (item.changeReasonCode && !item.confirmType) {
      return false
    }
    return true
  })
  // 必填校验
  if (!isQuired) {
    _processSkuList.value = _list.map((item: any) => {
      if (item.changeReasonCode && !item.confirmType) {
        return { ...item, hasNoContent: true }
      }
      return item
    })
    return
  } else {
    _processSkuList.value = JSON.parse(JSON.stringify(_list))
  }
  /** 存放总共几种运输方式 */
  const recommendShip = new Set()
  /** 重新重组下数据 */
  const confirmSkuList = _processSkuList.value?.map((item: any) => {
    let _confirmType: undefined | number = ['RECOMMEND', 'CANCEL', 'REMAINING'].indexOf(item.confirmType)
    _confirmType = _confirmType === -1 ? undefined : _confirmType + 1
    // _arr.set()
    // 建议运输方式
    if (_confirmType === 1) {
      recommendShip.add(item.recommendShipConfigId)
    } else if (_confirmType === 3) {
      recommendShip.add(item.originalDistributionId)
    }
    return {
      deliveryReviewDetailId: item.deliveryReviewDetailId,
      confirmType: _confirmType,
      systemOrderNo: item.systemOrderNo
    }
  })

  const params = {
    deliveryReviewCode: props.rowItem.deliveryReviewCode,
    platformOrderNo: props.rowItem.platformOrderNo,
    confirmSkuList
  }

  submitApi(params).then((res: any) => {
    if (!res.success) return
    // const handlingWaysRecommend = confirmSkuList.every((item: any) => item.confirmType === 1)
    const handlingWaysRemaining = confirmSkuList.every((item: any) => item.confirmType === 3)
    // if (handlingWaysRecommend) {
    //   ElMessage.success(t('成功，此国际发货单将按照建议运输方式发货'))
    //   emit('closeDialog', { deliveryProcessType: 0, visible: false })
    //   emit('refresh')
    //   return
    // }
    if (handlingWaysRemaining) {
      ElMessage.success(t('成功，此国际发货单将保持原运输方式发货'))
      emit('closeDialog', { deliveryProcessType: 0, visible: false })
      emit('refresh')
      return
    }
    emit('closeDialog', { visible: false, isNeedWatch: true, data: recommendShip.size }, props.rowItem)
  })
}
/** 待确认-sku-若是有变更理由则展示不同样式 */
const tableRowClassName = ({ row }: { row: any }) => {
  // 如果是sku级别，且有取消发货标识
  if (props.deliveryProcessType === 1 && row.cancelDelivery) {
    return 'visibility-hidden-checkbox column-border-style'
  }
  //   如果建议运输方式和原运输方式一样
  if (row.originalDistributionId === row.recommendShipConfigId) {
    return 'visibility-hidden-checkbox column-border-style'
  }
  if (row.changeReasonCode && row.changeReasonCode !== 'AR_0000') {
    return 'style-high-light column-border-style'
  }
  return 'visibility-hidden-checkbox column-border-style'
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    class: _normalizeClass(["problem-handing-order-abnormal", _unref(useSite)()]),
    "custom-class": "problem-handing-order-abnormal",
    width: props.deliveryProcessType === 0 ? '600px' : '1050px',
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('closeDialog', false)))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_31, [
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(loading),
          onClick: submit,
          disabled: showSubmitDisabled.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", {
        class: _normalizeClass(` dialog-body-content ${props.deliveryProcessType === 0 ? '' : 'dialog-body-content-sku'}`)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('原运输方式')) + "：", 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.rowItem.originalDistribution), 1)
        ]),
        (props.deliveryProcessType === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('变更理由')) + "：", 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(changeReasonCodes)[__props.rowItem.changeReasonCode]), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('建议运输方式')) + "：", 1),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(__props.rowItem.recommendDistribution ?? _unref(t)('无可用运输方式')), 1),
                  (__props.rowItem.goodsCountry !== _unref(COUNTRY).KR)
                    ? _withDirectives((_openBlock(), _createElementBlock("a", {
                        key: 0,
                        target: "_blank",
                        style: {"text-decoration":"underline"},
                        href: _unref(expressCostPdf)()
                      }, _toDisplayString(_unref(t)('国际料金表')), 9, _hoisted_12)), [
                        [_vShow, __props.rowItem.goodsCountry !== _unref(COUNTRY).KR]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (props.deliveryProcessType === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(`${_unref(t)('请选择处理方式')}`) + " ", 1),
                  (__props.rowItem.changeReasonCode && !__props.rowItem.recommendDistribution)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('由于没有可用的运输方式，需要您取消发货')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_radio_group, {
                  modelValue: handlingWays.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((handlingWays).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      (__props.rowItem.changeReasonCode && __props.rowItem.recommendDistribution)
                        ? (_openBlock(), _createBlock(_component_el_radio, {
                            key: 0,
                            label: 'RECOMMEND'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('按照建议运输方式发货')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (__props.rowItem.changeReasonCode === 'AR_0010' && __props.rowItem.recommendShipConfigId !== '-1')
                        ? (_openBlock(), _createBlock(_component_el_radio, {
                            key: 0,
                            label: 'REMAINING'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('保持原运输方式发货')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_radio, { label: 'CANCEL' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('取消发货')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('商品信息')), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)('批量处理')), 1),
                    _createVNode(_component_el_select, {
                      "popper-class": "style-select-selected",
                      placeholder: _unref(t)('请选择处理方式'),
                      disabled: selectionSkuList.value?.length <= 0,
                      modelValue: batchValue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((batchValue).value = $event)),
                      onChange: changeBatchSelect
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _unref(t)('按照建议运输方式发货'),
                          value: 'RECOMMEND'
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _unref(t)('保持原运输方式发货'),
                          value: 'REMAINING'
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _unref(t)('取消发货'),
                          value: 'CANCEL'
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["placeholder", "disabled", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "handle-way-table",
                  id: "handle-way-table",
                  ref: (_value, _refs) => {
                    _refs['scrollview'] = _value
                  }
                }, [
                  _createVNode(STable, {
                    columns: _unref(skuDialogColumns),
                    onSelectionChange: handleSelectionChange,
                    tableConfig: _unref(tableConfigSkuDialog),
                    "table-data": _processSkuList.value,
                    tableRowClassName: tableRowClassName,
                    "header-row-class-name": "handle-way-header-row",
                    fixed: true,
                    "show-pagination": false,
                    height: 410
                  }, {
                    recommendDistributionHead: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_unref(t)('建议运输方式')) + " ", 1),
                        _withDirectives(_createElementVNode("a", {
                          class: "font-weight-normal",
                          target: "_blank",
                          style: {"text-decoration":"underline","transform":"scale(0.8)"},
                          href: _unref(expressCostPdf)()
                        }, _toDisplayString(_unref(t)('国际料金表')), 9, _hoisted_25), [
                          [_vShow, __props.rowItem.goodsCountry !== _unref(COUNTRY).KR]
                        ])
                      ])
                    ]),
                    productSkuImg: _withCtx(({ row }) => [
                      (row.cancelDelivery)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            class: "cancel-delievery-tag",
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('已取消')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_26, [
                        (row.productSkuImg)
                          ? (_openBlock(), _createBlock(ShoppingPreview, {
                              key: 0,
                              image: row.productSkuImg
                            }, null, 8, ["image"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_27, _toDisplayString(row.productTitleJp), 1)
                      ])
                    ]),
                    changeReason: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString((_unref(changeReasonCodes)[row.changeReasonCode] && row.originalDistributionId !==
                  row.recommendShipConfigId) ? _unref(changeReasonCodes)[row.changeReasonCode] : '-'), 1)
                    ]),
                    recommendDistribution: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(((row.changeReasonCode === 'AR_0000' || (row.originalDistributionId ===
                  row.recommendShipConfigId)) ? '-' : row.recommendDistribution) || _unref(t)('无可用运输方式')), 1)
                    ]),
                    handleWay: _withCtx(({ row }) => [
                      (((!!row.changeReasonCode && row.changeReasonCode !== 'AR_0000') && !row.cancelDelivery && row.originalDistributionId !== row.recommendShipConfigId))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_el_select, {
                              ref: selectRef,
                              "popper-class": `style-select-selected`,
                              required: "",
                              placeholder: _unref(t)('请选择处理方式'),
                              modelValue: row.confirmType,
                              "onUpdate:modelValue": ($event: any) => ((row.confirmType) = $event),
                              onChange: (val) => changeSelect(val, toRaw(row))
                            }, {
                              default: _withCtx(() => [
                                (row.recommendShipConfigId !== '-1')
                                  ? (_openBlock(), _createBlock(_component_el_option, {
                                      key: 0,
                                      label: _unref(t)('按照建议运输方式发货'),
                                      value: 'RECOMMEND'
                                    }, null, 8, ["label"]))
                                  : _createCommentVNode("", true),
                                (row.changeReasonCode === 'AR_0010' && row.recommendShipConfigId !== '-1')
                                  ? (_openBlock(), _createBlock(_component_el_option, {
                                      key: 1,
                                      label: _unref(t)('保持原运输方式发货'),
                                      value: 'REMAINING'
                                    }, null, 8, ["label"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_option, {
                                  label: _unref(t)('取消发货'),
                                  value: 'CANCEL'
                                }, null, 8, ["label"])
                              ]),
                              _: 2
                            }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue", "onChange"]),
                            (row.hasNoContent)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _hoisted_30,
                                  _createElementVNode("span", null, _toDisplayString(_unref(t)('请选择处理方式')), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["columns", "tableConfig", "table-data"])
                ], 512)
              ], 64))
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "width", "model-value"]))
}
}

})